<script setup>
import {computed, watch, onBeforeMount} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router'

import { can, isOwnerOrSuperUser } from '@/composables/useCan'
import { useFeatures } from '@/composables/useFeatures'

const store = useStore()
const route = useRoute()
const { showBillingPage } = useFeatures()
const orgId = computed(() => parseInt(route.params.org_id))
const org = computed(() => store.getters['org/getCurrent'])

onBeforeMount(() => {
  store.dispatch('org/fetchOrg', orgId.value)
})

watch(orgId, (newOrgId) => {
  store.dispatch('org/fetchOrg', newOrgId)
})

const tabs = computed(() => [
  { name: 'OrgSettings', label: 'General', visible: can('org', 'update', { orgId: orgId.value }) },
  { name: 'OrgMembers', label: 'Members', visible: true },
  { name: 'OrgRoles', label: 'Roles', visible: can('org_role', 'read', { orgId: orgId.value }) },
  { name: 'OrgApiKeys', label: 'API Keys', visible: isOwnerOrSuperUser(orgId.value) },
  { name: 'OrgBilling', label: 'Billing', visible: showBillingPage.value && can('org_billing', 'read', { orgId: orgId.value }) },
].filter(tab => tab.visible))
</script>

<template>
  <div v-if="org" :key="org.organization_id" class="flex items-start gap-6 p-3">
    <nav class="w-32 shrink-0 flex flex-col gap-0.5">
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.name, params: { org_id: orgId } }"
        class="rounded-md px-3 py-1.5 text-sm transition-colors"
        :class="(route.meta.navTab ?? route.name) === tab.name
          ? 'bg-muted font-semibold'
          : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'"
      >
        {{ tab.label }}
      </router-link>
    </nav>
    <div class="min-w-0 flex-1">
      <router-view></router-view>
    </div>
  </div>
</template>
